import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../assets/styles/vendor/vendor.scss";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { TabView, TabPanel } from "primereact/tabview";
import { format } from "date-fns";
import { Toast } from "primereact/toast";
import GV from "../../services/globalVar";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import ItemsService from "../../services/items";

//API call
import ContactsService from "../../services/contactsService";

const NewCustomer = forwardRef((props, ref) => {
  const { parentFunction, data, goBack } = props;
  const cos = new ContactsService();
  const its = new ItemsService();
  const [customerID, setCustomerID] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [date, setDate] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState();
  const [gstTreatmentDropDown, setGstTreatmentDropDown] = useState();
  const [selectedGstTreatment, setSelectedGstTreatment] = useState();
  const [isProcess, setIsProcess] = useState(false);
  const [getAutoPass, setGetAutoPass] = useState(false);
  const [isGstin, setIsGstin] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [shippingStateList, setShippingStateList] = useState([]);
  const [editData, setEditData] = useState(null);
  const [shippingTableData, setShippingTableData] = useState([]);
  const [showShippingModal, setShowShippingModal] = useState(false);
  const [editShippingIndex, setEditShippingIndex] = useState(null);
  const [isFromGrid, setIsFromGrid] = useState(false);

  const defaultValues = {
    cType: "",
    salType: "",
    fname: "",
    lname: "",
    cname: "",
    dname: "",
    email: "",
    con: "",
    website: "",
    pan: "",
    openingBalance: "",
    curType: "",

    bAddress1: "",
    bAddress2: "",
    bCity: "",
    bState: "",
    bCountry: "",
    bZipCode: "",
    bCode: "",

    shippingAddresses: [],

    gsttreatment: "",
    gstin: "",
    cst: "",
    tin: "",
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
    setValue,
    watch,
    getValues,
    trigger,
  } = useForm({ mode: "all", defaultValues });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "shippingAddresses",
  });

  let cId = props.data.customerId;

  const resetAsyncForm = async () => {
    reset();
  };

  watch(["bAddress1", "bAddress2", "bCity", "bState", "bCountry", "bZipCode"]);

  useImperativeHandle(ref, () => ({
    alertToggle() {
      reset({
        cType: "Business",
        salType: "",
        fname: "",
        lname: "",
        cname: "",
        dname: "",
        email: "",
        con: "",
        website: "",
        pan: "",
        openingBalance: "",
        curType: "",
        bAddress1: "",
        bAddress2: "",
        bCity: "",
        bState: "",
        bCountry: "",
        bZipCode: "",
        sAddress1: "",
        sAddress2: "",
        sCity: "",
        sState: "",
        sCountry: "",
        sZipCode: "",
        deliveryPoint: "",
        sacode: "",
        gsttreatment: "",
        gstin: "",
      });

      setEditData(null);
      setSelectedCurrency("");
      setIsSameAddress(false);
      onClick("displaynewCust");
    },

    alertToggledit(val) {
      onClickEdit("displaynewCust", val);
    },
  }));

  const businessList = [
    {
      id: 1,
      name: "Registered business - regular",
      value: "Registered business - regular",
    },
    {
      id: 2,
      name: "Registered business - composition",
      value: "Registered business - composition",
    },
    { id: 3, name: "Unregistered business", value: "Unregistered business" },
    { id: 4, name: "Consumer", value: "Consumer" },
    { id: 5, name: "Overseas", value: "Overseas" },
    { id: 6, name: "Special ecomoninc zone", value: "Special ecomoninc zone" },
    { id: 7, name: "Deemed export", value: "Deemed export" },
    { id: 8, name: "Tax deductor", value: "Tax deductor" },
    { id: 9, name: "SEZ developer", value: "SEZ developer" },
  ];
  // const [displaynewCust, setDisplaynewCust] = useState(false);
  const [displaynewCust, setDisplaynewCust] = useState(false);
  const [position, setPosition] = useState("center");

  const handleDateChange = (date) => {
    setDate(format(new Date(date), "MM/dd/yyyy"));
  };

  const handleGSTtreatment = (e) => {
    setIsGstin(false);
    const selectedValue = e.target.value;
    const selectedValue1 = e.target;
    switch (selectedValue) {
      case "Registered business - regular":
        setIsGstin(true);
        break;

      case "Registered business - composition":
        setIsGstin(true);
        break;

      case "Unregistered business":
        break;

      case "Consumer":
        break;

      case "Overseas":
        break;

      case "Special ecomoninc zone":
        break;

      case "Deemed export":
        setIsGstin(true);
        break;

      case "Tax deductor":
        setIsGstin(true);
        break;

      case "SEZ developer":
        setIsGstin(true);
        break;

      default:
        break;
    }
  };

  const salutation = [
    { label: "Mr.", value: "Mr." },
    { label: "Ms.", value: "Ms." },
    { label: "Mrs.", value: "Mrs." },
    { label: "Miss.", value: "Miss." },
    { label: "Dr.", value: "Dr." },
  ];

  const currency = [
    { label: "INR-Indian Rupee", value: "INR" },
    { label: "Dollar", value: "Dlr" },
    { label: "Euro", value: "Ero" },
    { label: "Soil", value: "Sol" },
  ];
  const toast = useRef(null); //2

  const dialogFuncMap = {
    displaynewCust: setDisplaynewCust,
  };


const onClickEdit = async (name, value) => {
  console.log("value", value);
  setIsFromGrid(true);
  setIsProcess(true);
  dialogFuncMap[`${name}`](true);
  const res = await its.GetMasCountryList();
  if (res.data.statusCode === 200) {
    setCountryList(res.data.data || []);
    const shippingAddresses = (value.shippingAddressList || []).map((item) => {
      const matchedCountry = res.data.data.find(
        (c) => c.countryName === item.saCountry
      );
      
      return {
        sAddress1: item.saAddress1,
        sAddress2: item.saAddress2,
        sCity: item.saCity,
        sZipCode: item.saZipCode,
        deliveryPoint: item.saAttention || "",
        sacode: item.saStateCode || "",
        sCountry: matchedCountry?.countryID || null,
        sState: null, 
        sCountryName: item.saCountry,
        sStateName: item.saState,
        shippingAddressID: item.shippingAddressID,
        contactID: item.contactID,
      };
    });
    
    setShippingTableData(shippingAddresses);
    
    reset({
      cType: value.customerType,
      salType: value.salutation,
      fname: value.firstName,
      lname: value.lastName,
      cname: value.companyName,
      dname: value.displayName,
      email: value.email,
      con: value.phone,
      website: value.website,
      pan: value.pan,
      openingBalance: value.openingBalance,
      curType: value.currency_Code,
      bAddress1: value.baAddress1,
      bAddress2: value.baAddress2,
      bCity: value.baCity,
      bState: value.baState,
      bCountry: value.baCountry,
      bZipCode: value.baZipCode,
      bCode:value.baStateCode,
      gsttreatment: value.gstTreatment,
      gstin: value.gstNumber,
      cst: value.cstNumber,
      tin: value.tinNumber,
      shippingAddresses: [],
    });

    const selectedCountry = res.data.data.find(
      (c) => c.countryName === value.baCountry
    );

    let billingStateList = [];
    let selectedState = null;

    if (selectedCountry?.countryID) {
      const billingStateRes = await its.GetMasCountryStateList(
        selectedCountry.countryID
      );
      if (billingStateRes?.data?.statusCode === 200) {
        billingStateList = billingStateRes.data.data || [];
        setStateList(billingStateList); 
        selectedState = billingStateList.find(
          (s) => s.stateName === value.baState
        ); 
      }
    }

    setCustomerDataBillingAdd({
      bCountryID: selectedCountry?.countryID || null,
      bCountry: selectedCountry?.countryName || "",
      bStateID: selectedState?.stateID || null,
      bState: selectedState?.stateName || "",
    });

    setCustomerID(value.ContactID);
    const findCurrency = currency.find(
      (a) => a.value === value.currencySymbol
    );
    setSelectedCurrency(findCurrency?.value);

    setIsSameAddress(
      value.baAddress1 === value.saAddress1 &&
        value.baAddress2 === value.saAddress2 &&
        value.baCity === value.saCity &&
        value.baState === value.saState &&
        value.baCountry === value.saCountry &&
        value.baZipCode === value.saZipCode
    );
  }
  
  if (position) {
    setPosition(position);
  }

  setEditData(value);
};

  useEffect(() => {
    const loadStateList = async () => {
      if (editData && countryList.length > 0) {
        const matchedCountry = countryList.find(
          (c) => c.countryName === editData.baCountry
        );

        const selectedCountryID = matchedCountry?.countryID;

        setCustomerDataBillingAdd((prev) => ({
          ...prev,
          bCountryID: selectedCountryID,
          bCountry: matchedCountry?.countryName,
        }));

        if (selectedCountryID) {
          const res = await GetMasCountryStateList(selectedCountryID);
          const matchedState = res?.data?.data?.find(
            (s) => s.stateName === editData.baState
          );

          setCustomerDataBillingAdd((prev) => ({
            ...prev,
            bStateID: matchedState?.stateID,
            bState: matchedState?.stateName,
          }));
        }
      }
    };

    loadStateList();
  }, [editData, countryList]);

  const onClick = (name, position) => {
    dialogFuncMap[`${name}`](true);
    // setCType("");
    resetAsyncForm();
    setCustomerID(0);

    setValue("salType", salutation[0].value);
    // setValue('accntActive', true)
    // setValue('accntCode',accntTypes[0].value)
    //  setValue('accntName',accntTypes[0].value)
    if (position) {
      setPosition(position);
    }
  };

  const onHide = (name) => {
    setSelectedCurrency("");
    setIsSameAddress(false);
    reset();
    setCustomerDataBillingAdd({
      bCountryID: null,
      bCountry: "",
      bStateID: null,
      bState: "",
    });

    dialogFuncMap[`${name}`](false);
  };

  const onSubmit = (data) => {
    setIsProcess(true);

    const currentInput = getValues("shippingAddresses[0]");
    const isFilled = currentInput && typeof currentInput === "object"
        ? Object.values(currentInput).some((v) => v && v !== "")
        : false;

    let finalShippingList = [...shippingTableData];

    if (isFilled) {
      const countryObj = countryList.find((c) => c.countryID === currentInput.sCountry);
      const stateObj = (shippingStateList[0] || []).find((s) => s.stateID === currentInput.sState);
      const processedInput = {
        ...currentInput,
        sCountry: countryObj?.countryName || currentInput.sCountryName || "",
        sState: stateObj?.stateName || currentInput.sStateName || "",
        sCountryName: countryObj?.countryName || currentInput.sCountryName || "",
        sStateName: stateObj?.stateName || currentInput.sStateName || "",
      };

      if (editShippingIndex !== null) {
        finalShippingList[editShippingIndex] = processedInput;
      } else {
        finalShippingList.push(processedInput);
      }
    }

    const opBal = Number(data.openingBalance || 0);

    const datas = {
      ContactID: cId || 0,
      CustomerType: data.cType,
      Salutation: data.salType,
      FirstName: data.fname,
      LastName: data.lname,
      CompanyName: data.cname,
      DisplayName: data.dname,
      Email: data.email,
      Phone: data.con,
      SkypeNameNumber: "",
      Designation: "",
      Department: "",
      Website: data.website,
      PAN: data.pan,
      GSTTreatment: data.gsttreatment,
      GSTNumber: data.gstin,
      CSTNumber: data.cst,
      TINNumber: data.tin,
      Supply: "",
      CurrencyName: "",
      CurrencyCode: "",
      CurrencySymbol: selectedCurrency,
      ExchangeRate: 90.45,
      PaymentTerms: "",
      TDS: "",
      Facebook: "",
      Twitter: "",
      Remarks: "",
      TenantID: GV.userDet.tenantDetail.tenantID,
      BAAttention: "",
      BACountry: customerDataBillingAdd.bCountry?.trim() || "",
      BAAddress1: data.bAddress1?.trim() || "",
      BAAddress2: data.bAddress2?.trim() || "",
      BACity: data.bCity?.trim() || "",
      BAState: customerDataBillingAdd.bState?.trim() || "",
      BAZipCode: data.bZipCode?.trim() || "",
      BAStateCode: data.bCode?.trim() || "",
      BAPhone: "",
      BAFax: "",
      SAPhone: "",
      SAFax: "",
  ShippingAddressList: finalShippingList.map((field, index) => {
  const countryObj = countryList.find((c) => c.countryID === field.sCountry);
  const stateObj = Array.isArray(shippingStateList[index])
    ? shippingStateList[index].find((s) => s.stateID === field.sState)
    : null;

  return {
    SAAttention: field.deliveryPoint?.trim() || "",
    SAAddress1: field.sAddress1?.trim() || "",
    SAAddress2: field.sAddress2?.trim() || "",
    SACity: field.sCity?.trim() || "",
    SAState: (stateObj?.stateName || field.sStateName || "").trim(),
    SACountry: (countryObj?.countryName || field.sCountryName || "").trim(),
    SAZipCode: field.sZipCode?.trim() || "",
    SAStateCode: field.sacode?.trim() || "",
    IsPrimary: true,
    TenantID: GV.userDet.tenantDetail.tenantID,
    CreatedBy: GV.userDet.appUser.appuserID,
    ShippingAddressID: field.shippingAddressID || 0,
    ContactID: field.contactID || 0,
  };
}),

      Status: "Active",
      OpeningBalance: opBal,
      ClosingBalance: 5000.75,
      CreatedBy: GV.userDet.appUser.appuserID.toString(),
      Date: date,
    };
    cos
      .SaveCustomer(datas)
      .then((res) => {
        setIsProcess(false);
        if (res.data.statusCode === 200) {
          props.parentFunction();
          toast.current.show({
            severity: "success",
            summary: res.data.message,
          });
          goBack();
          setIsSameAddress(false);
          setEditShippingIndex(null); 
        }
      })
      .catch((error) => {
        setIsProcess(false);
        if (error?.response?.data?.message === "Customer Already Exists") {
          toast.current.show({
            severity: "error",
            summary: "Customer Already Exists",
          });
        }
      });
  };

  const renderFooter = (name) => {
    return (
      <div className="my-3">
        <Button
          label="Cancel"
          icon="pi pi-times"
          onClick={() => onHide("displaynewCust")}
          className="btn btn-danger me-2"
        />

        <Button
          type="submit"
          label={cId != "" || cId != 0 ? "Update" : "Save"}
          icon="pi pi-check"
          onClick={handleSubmit(onSubmit)}
          autoFocus
          className="btn btn-primary"
        />
        {/* <Button type="submit" label="Update" icon="pi pi-check" onClick={handleSubmit((onSubmit))} autoFocus className='btn btn-primary' /> */}
      </div>
    );
  };

  const [customerDataBillingAdd, setCustomerDataBillingAdd] = useState({
    bAddress1: "",
    bAddress2: "",
    bCity: "",
    bState: "",
    bCountry: "",
    bZipCode: "",
    bCode: "",
  });

  const [isSameAddress, setIsSameAddress] = useState(false);


  useEffect(() => {
    setGstTreatmentDropDown(businessList);
  }, []);

  useEffect(() => {
    register("salType");
    // register("cType");
  }, [register]);

  const GetMasCountryList = () => {
    its
      .GetMasCountryList()
      .then((res) => {
        if (res.data.statusCode === 200) {
          setCountryList(res.data.data);
        }
      })
      .catch(function (error) {});
  };

  const GetMasCountryStateList = (countryId, type, index = null) => {
    setIsProcess(true);

    if (!countryId) {
      setIsProcess(false);
      return Promise.resolve({ data: { data: [], statusCode: 400 } });
    }

    return its
      .GetMasCountryStateList(countryId)
      .then((res) => {
        if (res.data.statusCode === 200) {
          const stateData = Array.isArray(res.data.data) ? res.data.data : [];

          if (type === "billing") {
            setStateList(stateData);
          } else if (type === "shipping" && index !== null) {
            setShippingStateList((prev) => {
              const updated = [...prev];
              updated[index] = stateData;
              return updated;
            });
          }
        }
        setIsProcess(false);
        return res;
      })
      .catch((err) => {
        console.error("error", err);
        setIsProcess(false);
        return { data: { data: [], statusCode: 500 } };
      });
  };


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

const handleAddToTable = (index) => {
  const address = getValues(`shippingAddresses[${index}]`);
  const isEmpty = Object.values(address).every((v) => !v || v === null);
  if (isEmpty) return;

  const countryObj = countryList.find(
    (c) => c.countryID === address.sCountry
  );

  const stateObj = Array.isArray(shippingStateList[index])
    ? shippingStateList[index].find((s) => s.stateID === address.sState)
    : null;

  const finalAddress = {
    ...address,
    sCountry: countryObj?.countryName || address.sCountryName || "",
    sState: stateObj?.stateName || address.sStateName || "",
    sCountryName: countryObj?.countryName || address.sCountryName || "",
    sStateName: stateObj?.stateName || address.sStateName || "",
  };

  if (editShippingIndex !== null && editShippingIndex >= 0) {
    const updatedData = [...shippingTableData];
    updatedData[editShippingIndex] = finalAddress;
    setShippingTableData(updatedData);
    setEditShippingIndex(null);
  } else {
    setShippingTableData((prev) => [...prev, finalAddress]);
  }

  remove(index);
};

  const handleDeleteShippingAddress = (index) => {
    const updated = [...shippingTableData];
    updated.splice(index, 1);
    setShippingTableData(updated);
  };
const handleEditShipping = async (index) => {
  try {
    const item = shippingTableData[index];
    let countryID = null;
    let countryName = item.sCountryName || "";

    if (typeof item.sCountry === 'number' && item.sCountry !== null) {
      countryID = item.sCountry;
    } else if (typeof item.sCountry === 'string' || item.sCountryName) {
      const matchedCountry = countryList.find(
        (c) => c.countryName === (item.sCountryName || item.sCountry)
      );
      countryID = matchedCountry?.countryID || null;
      countryName = matchedCountry?.countryName || item.sCountryName || "";
    }

    if (countryID) {
      const stateRes = await GetMasCountryStateList(
        countryID, 
        "shipping",
        0
      );
      
      if (stateRes?.data?.statusCode === 200) {
        const states = Array.isArray(stateRes.data.data) ? stateRes.data.data : [];
        
        setShippingStateList(prev => {
          const newStateList = [...prev];
          newStateList[0] = states;
          return newStateList;
        });
        
        // Find state by name or ID
        let matchState = null;
        if (typeof item.sState === 'number' && item.sState !== null) {
          matchState = states.find((s) => s.stateID === item.sState);
        } else {
          matchState = states.find((s) => s.stateName === item.sStateName);
        }
        
        remove(); 
        append({
          sAddress1: item.sAddress1 || "",
          sAddress2: item.sAddress2 || "",
          sCity: item.sCity || "",
          sState: matchState?.stateID || null,
          sStateName: matchState?.stateName || item.sStateName || "",
          sCountry: countryID,
          sCountryName: countryName,
          sZipCode: item.sZipCode || "",
          deliveryPoint: item.deliveryPoint || "",
          sacode: item.sacode || "",
          shippingAddressID: item.shippingAddressID || null,
          contactID: item.contactID || null,
        });

        setEditShippingIndex(index);
      }
    } else {
      // If no valid country found, just populate the form
      remove(); 
      append({
        sAddress1: item.sAddress1 || "",
        sAddress2: item.sAddress2 || "",
        sCity: item.sCity || "",
        sState: null,
        sStateName: item.sStateName || "",
        sCountry: null,
        sCountryName: countryName,
        sZipCode: item.sZipCode || "",
        deliveryPoint: item.deliveryPoint || "",
        sacode: item.sacode || "",
        shippingAddressID: item.shippingAddressID || null,
        contactID: item.contactID || null,
      });

      setEditShippingIndex(index);
    }
  } catch (err) {
    console.error("error", err);
  }
};

  const handleNewShipping = (index) => {
    // const item = shippingTableData[index];
    remove();
    append({
      sAddress1: "",
      sAddress2: "",
      sCity: "",
      sState: null,
      sStateName: "",
      sCountry: null,
      sCountryName: "",
      sZipCode: "",
      deliveryPoint: "",
      sacode: "",
      shippingAddressID: 0,
      contactID: 0,
    });

    setEditShippingIndex(index);
  };

  const cancelAddress = () => {
    remove();
  };

  useEffect(() => {
    GetMasCountryList();
  }, []);

  return (
    <div>
      <Toast ref={toast}></Toast>
      <BlockUI blocked={isProcess}>
        <div className="row mx-auto">
          <div
            className="col-md d-flex cc-greyCard-custm justify-content-between align-items-center my-3 p-2 "
            style={{ background: "white" }}
          >
            <div className="ms-2 my-2 me-2">
              <div>
                <h4 className="mb-0 ">
                  {cId !== "" && cId !== 0 ? "Update Customer" : "New Customer"}
                </h4>
              </div>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-danger "
                onClick={goBack}
              >
                Back to Customers
              </button>
            </div>
          </div>
        </div>
        <div className="card shadow-lg border-0">
          <div className="card-body px-4 py-0">
            <form>
              <div className="rounded py-3 ">
                <label className="form-label  mb-3">
                  Customer Type <span className="text-danger">*</span>
                </label>
                <div className="d-flex gap-4">
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="business"
                      {...register("cType", { required: true })}
                      value="Business"
                    />
                    <label
                      className="form-check-label fw-medium"
                      htmlFor="business"
                    >
                      Business
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="individual"
                      {...register("cType", { required: true })}
                      value="Individual"
                    />
                    <label
                      className="form-check-label fw-medium"
                      htmlFor="individual"
                    >
                      Individual
                    </label>
                  </div>
                </div>
                {errors.cType && (
                  <div className="text-danger mt-2 small fw-medium">
                    This field is required
                  </div>
                )}
              </div>

              <div className="mb-4">
                <h5 className=" mb-2 p-inv-bghead">Personal Information</h5>
                <div className="row g-3">
                  <div className="col-md-3 mt-1">
                    <label className="form-label">Salutation</label>
                    <Controller
                      render={({ field }) => (
                        <Dropdown
                          className="form-control custom-placeholder"
                          options={salutation}
                          {...field}
                          appendTo="self"
                          optionLabel="label"
                          optionValue="value"
                        />
                      )}
                      control={control}
                      name="salType"
                      defaultValue={customerData?.salType}
                    />
                  </div>

                  <div className="col-md-3 mt-1">
                    <label className="form-label">
                      First Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerData?.fname}
                      onChange={(e) => setCustomerData(...e.target.value)}
                      {...register("fname", { required: true })}
                      placeholder="Enter first name"
                    />
                    {errors.fname && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3 mt-1">
                    <label className="form-label">
                      Last Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerData?.lname}
                      onChange={(e) => setCustomerData(...e.target.value)}
                      {...register("lname", { required: true })}
                      placeholder="Enter last name"
                    />
                    {errors.lname && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3 mt-1">
                    <label className="form-label">
                      Company Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerData?.cname}
                      onChange={(e) => setCustomerData(...e.target.value)}
                      {...register("cname", { required: true })}
                      placeholder="Enter company name"
                    />
                    {errors.cname && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3 mt-1">
                    <label className="form-label">
                      Display Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerData?.dname}
                      onChange={(e) => setCustomerData(...e.target.value)}
                      {...register("dname", { required: true })}
                      placeholder="Enter display name"
                    />
                    {errors.dname && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3 mt-1">
                    <label className="form-label">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control custom-placeholder"
                      defaultValue={customerData?.email}
                      onChange={(e) => setCustomerData(...e.target.value)}
                      {...register("email", {
                        required: "This field is required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        },
                      })}
                      placeholder="Enter email address"
                    />
                    {errors.email && (
                      <div className="text-danger mt-1 small fw-medium">
                        {errors.email.message}
                      </div>
                    )}
                  </div>

                  <div className="col-md-3 mt-1">
                    <label className="form-label">
                      Contact <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control custom-placeholder"
                      defaultValue={customerData?.con}
                      onChange={(e) => setCustomerData(...e.target.value)}
                      {...register("con", { required: true })}
                      placeholder="Enter contact number"
                    />
                    {errors.con && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h5 className=" mb-2 p-inv-bghead ">Tax Information</h5>
                <div className="row g-3">
                  <div className="col-md-3 mt-1">
                    <label className="form-label">
                      GST Treatment <span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="gsttreatment"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          value={field.value}
                          onChange={(e) => {
                            field.onChange(e.value);
                            handleGSTtreatment(e);
                          }}
                          options={gstTreatmentDropDown}
                          optionLabel="name"
                          placeholder="Select your business type"
                          className="form-control custom-placeholder"
                        />
                      )}
                    />
                    {errors.gsttreatment && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3 mt-1">
                    <label className={`form-label`}>
                      GSTIN {isGstin && <span className="text-danger">*</span>}
                    </label>
                    <Controller
                      name="gstin"
                      control={control}
                      rules={{
                        required: isGstin ? "GSTIN number is required" : false,
                      }}
                      render={({ field }) => (
                        <input
                          type="text"
                          className="form-control custom-placeholder"
                          placeholder="Enter GSTIN number"
                          {...field}
                        />
                      )}
                    />
                    {errors.gstin && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3 mt-1">
                    <label className="form-label">PAN</label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerData?.pan}
                      onChange={(e) => setCustomerData(...e.target.value)}
                      {...register("pan", { required: false })}
                      placeholder="Enter PAN number"
                    />
                    {errors.pan && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3 mt-1">
                    <label className="form-label">CST</label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerData?.cst}
                      onChange={(e) => setCustomerData(...e.target.value)}
                      {...register("cst", { required: false })}
                      placeholder="Enter CST number"
                    />
                    {errors.cst && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3 mt-1">
                    <label className="form-label">TIN</label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerData?.tin}
                      onChange={(e) => setCustomerData(...e.target.value)}
                      {...register("tin", { required: false })}
                      placeholder="Enter TIN number"
                    />
                    {errors.tin && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {isProcess && (
                <div className="position-fixed top-50 start-50 translate-middle">
                  <ProgressSpinner
                    style={{
                      width: "50px",
                      height: "50px",
                    }}
                    strokeWidth="2"
                    fill="var(--surface-ground)"
                    animationDuration=".5s"
                  />
                </div>
              )}

              <div className="mb-4">
               
                <h5 className=" mb-3 p-inv-bghead">
                  Billing Address Information
                </h5>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label">
                      Address 1 <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerDataBillingAdd?.bAddress1}
                      onInput={(e) => {
                        setCustomerDataBillingAdd((prevData) => ({
                          ...prevData,
                          bAddress1: e.target.value,
                        }));
                        setIsSameAddress(false);
                      }}
                      {...register("bAddress1", { required: true })}
                      placeholder="Enter address line 1"
                    />
                    {errors.bAddress1 && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Address 2</label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerDataBillingAdd?.bAddress2}
                      onInput={(e) => {
                        setCustomerDataBillingAdd((prevData) => ({
                          ...prevData,
                          bAddress2: e.target.value,
                        }));
                        setIsSameAddress(false);
                      }}
                      {...register("bAddress2", { required: false })}
                      placeholder="Enter address line 2 (optional)"
                    />
                    {errors.bAddress2 && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">
                      Country <span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="bCountry"
                      control={control}
                      rules={{ required: "This field is required" }}
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          value={customerDataBillingAdd?.bCountryID || null}
                          onChange={(e) => {
                            const selectedCountry = countryList.find(
                              (c) => c.countryID === e.value
                            );
                            field.onChange(e.value);
                            setCustomerDataBillingAdd((prev) => ({
                              ...prev,
                              bCountryID: selectedCountry?.countryID,
                              bCountry: selectedCountry?.countryName,
                            }));
                            GetMasCountryStateList(
                              selectedCountry?.countryID,
                              "billing"
                            );
                            setIsSameAddress(false);
                          }}
                          options={countryList}
                          optionLabel="countryName"
                          optionValue="countryID"
                          placeholder="Select a Country"
                          filter
                          showClear
                          className={`w-100 ${
                            errors.bCountry ? "border-danger" : ""
                          }`}
                        />
                      )}
                    />
                    {errors.bCountry && (
                      <div className="text-danger mt-1 small fw-medium">
                        {errors.bCountry.message}
                      </div>
                    )}
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">
                      State <span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="bState"
                      control={control}
                      rules={{ required: "This field is required" }}
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          value={customerDataBillingAdd?.bStateID || null}
                          onChange={(e) => {
                            const selectedState = stateList.find(
                              (s) => s.stateID === e.value
                            );
                            field.onChange(e.value);
                            setCustomerDataBillingAdd((prev) => ({
                              ...prev,
                              bStateID: selectedState?.stateID,
                              bState: selectedState?.stateName,
                            }));
                            setIsSameAddress(false);
                          }}
                          options={stateList}
                          optionLabel="stateName"
                          optionValue="stateID"
                          placeholder="Select a State"
                          filter
                          showClear
                          className={`w-100 ${
                            errors.bState ? "border-danger" : ""
                          }`}
                        />
                      )}
                    />
                    {errors.bState && (
                      <div className="text-danger mt-1 small fw-medium">
                        {errors.bState.message}
                      </div>
                    )}
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">
                      City <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerDataBillingAdd?.bCity}
                      onInput={(e) => {
                        setCustomerDataBillingAdd((prevData) => ({
                          ...prevData,
                          bCity: e.target.value,
                        }));
                        setIsSameAddress(false);
                      }}
                      {...register("bCity", { required: true })}
                      placeholder="Enter city"
                    />
                    {errors.bCity && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">
                      Zip/Postal Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerDataBillingAdd?.bZipCode}
                      onInput={(e) => {
                        setCustomerDataBillingAdd((prevData) => ({
                          ...prevData,
                          bZipCode: e.target.value,
                        }));
                        setIsSameAddress(false);
                      }}
                      {...register("bZipCode", { required: true })}
                      placeholder="Enter zip/postal code"
                    />
                    {errors.bZipCode && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">
                      Code 
                    </label>
                    <input
                      type="text"
                      className="form-control custom-placeholder"
                      defaultValue={customerDataBillingAdd?.bCode}
                      onInput={(e) => {
                        setCustomerDataBillingAdd((prevData) => ({
                          ...prevData,
                          bCode: e.target.value,
                        }));
                        setIsSameAddress(false);
                      }}
                      {...register("bCode", { required: false })}
                      placeholder="Enter zip/postal code"
                    />
                    {errors.bCode && (
                      <div className="text-danger mt-1 small fw-medium">
                        This field is required
                      </div>
                    )}
                  </div>
                </div>


                <div className="mt-3">
                  <div className="d-flex justify-content-between mb-3 p-inv-bghead">
                    <h5>Shipping Address Information</h5>
                    <button
                      type="button"
                      className="btn btn-info btn-sm ms-4 "
                      onClick={() =>
                        handleNewShipping(shippingTableData.length)
                      }
                    >
                      Add New Address
                    </button>
                  </div>

                  {fields.map((field, index) => (
                    <div
                      key={field.id}
                      className="card mb-4 border border-0 mt-4"
                    >
                      <div
                        className="card-header mb-0 d-flex justify-content-between align-items-center border-0"
                        style={{ backgroundColor: "#ebebeb" }}
                      >
                        <h6 className="mb-0">
                          Shipping Address{" "}
                          {editShippingIndex !== null &&
                            `(Row #${editShippingIndex + 1})`}
                        </h6>
                      </div>

                      <div
                        className="card-body card-border"
                        style={{ background: "aliceblue" }}
                      >
                        <div className="row g-3">
                          <div className="col-md-3 mt-1">
                            <label className="form-label">Address 1</label>
                            <input
                              type="text"
                              className="form-control custom-placeholder"
                              placeholder="Enter address line 1"
                              {...register(
                                `shippingAddresses[${index}].sAddress1`
                              )}
                            />
                          </div>

                          <div className="col-md-3 mt-1">
                            <label className="form-label">Address 2</label>
                            <input
                              type="text"
                              className="form-control custom-placeholder"
                              placeholder="Enter address line 2"
                              {...register(
                                `shippingAddresses[${index}].sAddress2`
                              )}
                            />
                          </div>

                          <div className="col-md-3 mt-1">
                            <label className="form-label">Country</label>
                            <Controller
                              name={`shippingAddresses[${index}].sCountry`}
                              control={control}
                              render={({ field }) => (
                                <Dropdown
                                  key={watch(
                                    `shippingAddresses[${index}].sCountry`
                                  )}
                                  {...field}
                                  value={field.value || null}
                                  onChange={(e) => {
                                    const selectedCountry = countryList.find(
                                      (c) => c.countryID === e.value
                                    );
                                    field.onChange(e.value);
                                    setValue(
                                      `shippingAddresses[${index}].sCountryName`,
                                      selectedCountry?.countryName
                                    );
                                    GetMasCountryStateList(
                                      selectedCountry?.countryID,
                                      "shipping",
                                      index
                                    );
                                  }}
                                  options={countryList}
                                  optionLabel="countryName"
                                  optionValue="countryID"
                                  placeholder="Select a Country"
                                  filter
                                  showClear
                                  className="w-100"
                                />
                              )}
                            />
                          </div>

                          <div className="col-md-3 mt-1">
                            <label className="form-label">State</label>
                            <Controller
                              name={`shippingAddresses[${index}].sState`}
                              control={control}
                              render={({ field }) => (
                                <Dropdown
                                  key={watch(
                                    `shippingAddresses[${index}].sState`
                                  )}
                                  {...field}
                                  value={field.value || null}
                                  onChange={(e) => {
                                    const selectedState =
                                      shippingStateList.find(
                                        (s) => s.stateID === e.value
                                      );
                                    field.onChange(e.value);
                                    setValue(
                                      `shippingAddresses[${index}].sStateName`,
                                      selectedState?.stateName || ""
                                    );
                                  }}
                                  options={
  Array.isArray(shippingStateList[index])
    ? shippingStateList[index]
    : []
}

                                  optionLabel="stateName"
                                  optionValue="stateID"
                                  placeholder="Select a State"
                                  filter
                                  showClear
                                  className="w-100"
                                />
                              )}
                            />
                          </div>

                          <div className="col-md-3">
                            <label className="form-label">City</label>
                            <input
                              type="text"
                              className="form-control custom-placeholder"
                              placeholder="Enter city"
                              {...register(`shippingAddresses[${index}].sCity`)}
                            />
                          </div>

                          <div className="col-md-3">
                            <label className="form-label">
                              Zip/Postal Code
                            </label>
                            <input
                              type="text"
                              className="form-control custom-placeholder"
                              placeholder="Enter zip code"
                              {...register(
                                `shippingAddresses[${index}].sZipCode`
                              )}
                            />
                          </div>

                          <div className="col-md-3">
                            <label className="form-label">Delivery Point</label>
                            <input
                              type="text"
                              className="form-control custom-placeholder"
                              placeholder="Enter delivery point"
                              {...register(
                                `shippingAddresses[${index}].deliveryPoint`
                              )}
                            />
                          </div>

                          <div className="col-md-3">
                            <label className="form-label">Code</label>
                            <input
                              type="text"
                              className="form-control custom-placeholder"
                              placeholder="Enter code"
                              {...register(
                                `shippingAddresses[${index}].sacode`
                              )}
                            />
                          </div>
                        </div>

                        <div className=" text-end mt-3">
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => cancelAddress()}
                          >
                            Cancel
                          </button>

                          <button
                            type="button"
                            className="btn btn-primary btn-sm ms-3"
                            onClick={() => handleAddToTable(index)}
                          >
                            {editShippingIndex !== null
                              ? "Update Address"
                              : "Update Address"}
                          </button>
                        </div>
                      </div>
                      <div className="text-end mt-4"></div>
                    </div>
                  ))}
                  <table className="table table-bordered table-striped">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: "2%" }}>S.No</th>
                        <th style={{ width: "12%" }}>Address 1</th>
                        <th style={{ width: "12%" }}>Address 2</th>
                        <th style={{ width: "6%" }}>City</th>
                        <th style={{ width: "10%" }}>Country</th>
                        <th style={{ width: "6%" }}>State</th>
                        <th style={{ width: "5%" }}>Zip Code</th>
                        <th style={{ width: "7%" }}>Delivery Point</th>
                        <th style={{ width: "5%" }}>Code</th>
                        <th style={{ width: "4%" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shippingTableData.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.sAddress1}</td>
                          <td>{item.sAddress2}</td>
                          <td>{item.sCity}</td>
                          <td>{item.sCountryName}</td>
                          <td>{item.sStateName}</td>
                          <td>{item.sZipCode}</td>
                          <td>{item.deliveryPoint}</td>
                          <td>{item.sacode}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm rounded-circle mx-1"
                              onClick={() => handleEditShipping(index)}
                            >
                              <i
                                className="pi pi-pencil"
                                style={{ fontSize: "12px" }}
                              ></i>
                            </button>

                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm rounded-circle"
                              onClick={() => handleDeleteShippingAddress(index)}
                              style={{ width: "32px", height: "32px" }}
                            >
                              <i
                                className="pi pi-trash"
                                style={{ fontSize: "12px" }}
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="d-flex justify-content-end mt-4 pt-3">
                {renderFooter("displayNewCustomer")}
              </div>
            </form>
          </div>
        </div>
      </BlockUI>
    </div>
  );
});

export default NewCustomer;
